import { Box, Popover, Typography } from '@mui/material';
import React, { useState } from 'react'
import DeleteIcon from '../../assets/SVG/deleteIcon';
import UploadIcon from '../../assets/SVG/uploadIcon';

export default function UploadProfile({setAnchorEl,anchorEl,onChangeValueImage}) {
    // const [anchorEl, setAnchorEl] = useState(null);
    // const handleClick = (event) => {
    //     setAnchorEl(event.currentTarget);
    //   };
    
      const handleClose = () => {
        setAnchorEl(null);
      };
      const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
    // const onChangeValueImage = (event) => {
    //     const file = event.target.files[0];
    //     let url = window?.URL?.createObjectURL(file);
    
    //     setImage({ file: file, url: url });
    //     handleClose();
    //   };
    //   useEffect(() => {
    //     if (image) {
    //       let formDataImage = new FormData();
    //       formDataImage.append("file", image.file);
    //       putSetImageGroup(formDataImage)
    //         .then(() => console.log("shod"))
    //         .catch((err) => console.log("nashod"));
    //       // console.log(image);
    //     }
    //   }, [image]);
  return (
    <>
    <Popover
        sx={{
          "& .MuiPaper-root": {
            width: "100px",
            padding: "10px 10px",
            borderRadius: "13px",
            mt: "10px",
            bgcolor: "#F3F3F3",
          },
        }}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Box>
          <Box sx={{ cursor: "pointer" }} display="flex" alignItems="center">
            <UploadIcon />
            <Typography
              sx={{ cursor: "pointer" }}
              variant="contained"
              component="label"
              mr="5px"
              fontSize="11px"
            >
              <input
                // value={props.value}
                // onKeyDown={props.onKeyDown}
                onChange={onChangeValueImage}
                hidden
                accept={"image/gif,.jpg,.png, .WebP,.JPEG"}
                multiple
                type="file"
              />
              {"بارکذاری عکس"}
            </Typography>
          </Box>
          <Box
            mt="10px"
            sx={{ cursor: "pointer" }}
            display="flex"
            alignItems="center"
            onClick={() => {
            //   setImage();
              handleClose();
            }}
          >
            <DeleteIcon />
            <Typography mr="5px" fontSize="11px" color="var(--emr-red)">
              {"حذف عکس"}
            </Typography>
          </Box>
        </Box>
      </Popover>
    </>
  )
}
